import { type RegisteredRouter, useNavigate, type ValidateNavigateOptions } from '@tanstack/react-router'
import { useCallback } from 'react'

export function useNavigateTo<TRouter extends RegisteredRouter = RegisteredRouter, TOptions = unknown>(
  params: ValidateNavigateOptions<TRouter, TOptions>,
): () => void {
  const navigate = useNavigate()
  return useCallback(() => void navigate(params), [navigate, params])
}
